<template>
  <div class="pw-login-nav">
    <SignIn :sign_in_dialog="sign_in_dialog" @clicked="SignInDialogEmit" />

    <v-navigation-drawer
      v-model="drawer"
      app
      temporary
      width="280"
      class="pw-login-drawer"
    >
      <div class="pw-login-drawer__head">
        <v-img src="@/assets/img/logo.png" alt="PharmaWRK" max-width="130" />
      </div>
      <v-divider />
      <v-list nav density="comfortable" class="pa-2">
        <v-list-item
          v-for="(item, i) in items"
          :key="i"
          rounded="lg"
          :active="activeSection === item.link"
          color="primary"
          class="pw-login-drawer__item"
          @click="scrollToSection(item.link)"
        >
          <template #prepend>
            <v-icon
              size="20"
              :color="activeSection === item.link ? 'primary' : 'grey-darken-1'"
            >
              {{ item.icon }}
            </v-icon>
          </template>
          <v-list-item-title>{{ item.text }}</v-list-item-title>
        </v-list-item>
      </v-list>
      <template #append>
        <div class="pa-4">
          <v-btn
            block
            color="primary"
            variant="flat"
            class="gradient-bg text-white"
            rounded="lg"
            @click="openSignIn"
          >
            Sign In
          </v-btn>
        </div>
      </template>
    </v-navigation-drawer>

    <v-app-bar app flat elevation="0" class="pw-login-app-bar">
      <v-app-bar-nav-icon
        v-if="isXs"
        class="pw-login-app-bar__menu"
        @click.stop="drawer = !drawer"
      />
      <v-toolbar-title class="pw-login-app-bar__brand">
        <v-img src="@/assets/img/logo.png" alt="PharmaWRK" max-width="130" />
      </v-toolbar-title>
      <v-spacer />
      <div v-if="!isXs" class="pw-login-app-bar__links">
        <v-btn
          v-for="(item, i) in items"
          :key="i"
          variant="text"
          :class="[
            'pw-login-app-bar__link',
            { 'pw-login-app-bar__link--active': activeSection === item.link },
          ]"
          @click="scrollToSection(item.link)"
        >
          {{ item.text }}
        </v-btn>
        <v-btn
          variant="flat"
          color="primary"
          class="gradient-bg text-white pw-login-app-bar__signin ml-2"
          rounded="lg"
          @click="openSignIn"
        >
          Sign In
        </v-btn>
      </div>
      <v-btn
        v-else
        icon
        variant="text"
        color="primary"
        @click="openSignIn"
      >
        <v-icon>mdi-account-circle-outline</v-icon>
      </v-btn>
    </v-app-bar>

    <v-btn
      v-show="fab"
      v-scroll="onScroll"
      icon
      size="small"
      color="primary"
      class="pw-login-scroll-top gradient-bg"
      @click.stop="toTop"
    >
      <v-icon color="white">mdi-arrow-up</v-icon>
    </v-btn>
  </div>
</template>

<script>
import SignIn from "@/components/LoginPage/SignIn.vue";

export default {
  components: {
    SignIn,
  },
  props: {
    color: String,
    flat: Boolean,
  },
  data: () => ({
    drawer: false,
    sign_in_dialog: false,
    isXs: false,
    fab: false,
    activeSection: "#hero",
    items: [
      { icon: "mdi-home-outline", text: "Home", link: "#hero" },
      { icon: "mdi-information-outline", text: "About", link: "#features" },
      { icon: "mdi-email-outline", text: "Contact us", link: "#contact" },
    ],
  }),
  watch: {
    isXs(value) {
      if (!value && this.drawer) {
        this.drawer = false;
      }
    },
  },
  mounted() {
    this.onResize();
    window.addEventListener("resize", this.onResize, { passive: true });
    window.addEventListener("scroll", this.onScroll, { passive: true });
    this.$nextTick(() => this.updateActiveSection());
  },
  beforeUnmount() {
    window.removeEventListener("resize", this.onResize);
    window.removeEventListener("scroll", this.onScroll);
  },
  methods: {
    openSignIn() {
      this.drawer = false;
      this.sign_in_dialog = true;
    },
    scrollToSection(link) {
      this.drawer = false;
      this.activeSection = link;
      const element = document.querySelector(link);
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    },
    onScroll() {
      if (typeof window === "undefined") return;
      const top = window.pageYOffset || document.documentElement.scrollTop || 0;
      this.fab = top > 120;
      this.updateActiveSection(top);
    },
    updateActiveSection(scrollY) {
      const offset = 88;
      const currentScroll =
        scrollY ?? window.pageYOffset ?? document.documentElement.scrollTop ?? 0;
      let current = this.items[0].link;

      for (const item of this.items) {
        const el = document.querySelector(item.link);
        if (el && currentScroll + offset >= el.offsetTop) {
          current = item.link;
        }
      }

      this.activeSection = current;
    },
    toTop() {
      this.scrollToSection("#hero");
    },
    onResize() {
      this.isXs = window.innerWidth < 850;
    },
    SignInDialogEmit() {
      this.sign_in_dialog = false;
    },
  },
};
</script>
